export const state = initialState();

export const actions = {};

export const mutations = {};

export const getters = {};

function initialState() {
  return {
    cookiePolicyURL: {
      it: 'https://www.iubenda.com/privacy-policy/54589597/cookie-policy',
      en: 'https://www.iubenda.com/privacy-policy/12872322/cookie-policy',
      es: 'https://www.iubenda.com/privacy-policy/88474275/cookie-policy'
    },
    privacyPolicyURL: {
      it: 'https://www.iubenda.com/privacy-policy/54589597',
      en: 'https://www.iubenda.com/privacy-policy/12872322',
      es: 'https://www.iubenda.com/privacy-policy/88474275'
    }
  };
}
